<template>
  <v-card>
    <v-card-title>
      Záznamy ({{ count }})

      <v-spacer/>

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init()"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestYears
                        v-model="params.Filters.Year"
                        :error-messages="errors.Filters && errors.Filters.Year"
                        :outlined="true"
                        :dense="true"
                        label="Rok"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestCountries
                        v-model="params.Filters.Country"
                        :error-messages="errors.Filters && errors.Filters.Country"
                        :outlined="true"
                        :dense="true"
                        label="Krajina"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestDistricts
                        v-model="params.Filters.District"
                        :error-messages="errors.Filters && errors.Filters.District"
                        :outlined="true"
                        :dense="true"
                        label="Okres"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestCities
                        v-model="params.Filters.City"
                        :error-messages="errors.Filters && errors.Filters.City"
                        :outlined="true"
                        :dense="true"
                        label="Mesto"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.title"
                        :error-messages="errors.Filters && errors.Filters.title"
                        :outlined="true"
                        :dense="true"
                        label="Názov"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.family"
                        :error-messages="errors.Filters && errors.Filters.family"
                        :outlined="true"
                        :dense="true"
                        label="Priezvisko"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.type"
                        :error-messages="errors.Filters && errors.Filters.type"
                        :outlined="true"
                        :dense="true"
                        label="Typ"
                        :items="$store.getters['register/getRecordType']"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.format"
                        :error-messages="errors.Filters && errors.Filters.format"
                        :outlined="true"
                        :dense="true"
                        label="Formát"
                        :items="$store.getters['register/getRecordFormat']"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.status"
                        :error-messages="errors.Filters && errors.Filters.status"
                        :outlined="true"
                        :dense="true"
                        label="Stav"
                        :items="$store.getters['register/getRecordStatus']"
                        :clearable="true"
                        @change="setFilter()"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th
                          class="fixed"
                      >
                        <a
                            @click="setOrder($store.state.register.Record.Filter.order['title'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.Record.Filter.order['title'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.Record.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Názov
                        </a>
                      </th>

                      <th>
                        Priezviská
                      </th>

                      <th>
                        Typ
                      </th>

                      <th>
                        Formát
                      </th>

                      <th>
                        Stav
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="records.length > 0"
                    >
                      <tr
                          v-for="Record in records"
                          :key="Record.id"
                      >
                        <td
                            class="fixed"
                        >
                          <a
                              :href="Record.url"
                              target="_blank"
                          >
                            {{ Record.title }}
                          </a>
                        </td>

                        <td>
                          <template
                              v-if="Record.families"
                          >
                            {{ Record.families }}
                          </template>

                          <template
                              v-else
                          >
                            Nevyplnené
                          </template>
                        </td>

                        <td>
                          {{ $store.state.register.Record.type[Record.type].text }}
                        </td>

                        <td>
                          {{ $store.state.register.Record.format[Record.format].text }}
                        </td>

                        <td>
                          {{ $store.state.register.Record.status[Record.status].text }}
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <Update
                              :id="Record.id"
                              @init="init()"
                          />

                          &nbsp;

                          <Delete
                              :id="Record.id"
                              @init="init()"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="6"
                            class="text-center"
                        >
                          Nenašli sa žiadne záznamy.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getRecordFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage()"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage()"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Records from '@/services/records'

  import Update from '@/components/Records/Update'
  import Delete from '@/components/Records/Delete'

  import SuggestYears from '@/components/Years/Suggest'
  import SuggestCountries from '@/components/Countries/Suggest'
  import SuggestDistricts from '@/components/Districts/Suggest'
  import SuggestCities from '@/components/Cities/Suggest'

  export default {
    name: 'Records',
    components: {
      Update,
      Delete,
      SuggestYears,
      SuggestCountries,
      SuggestDistricts,
      SuggestCities
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        records: [],
        params: {
          Filters: {
            Year: '',
            Country: '',
            District: '',
            City: '',
            title: '',
            family: '',
            type: '',
            format: '',
            status: ''
          },
          order: this.$store.state.register.Record.Filter.order['title'].value,
          by: this.$store.state.register.Record.Filter.by['ASC'].value,
          limit: this.$store.state.register.Record.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Záznamy'
      }
    },
    beforeMount() {
      this.params = {
        ...this.params,
        ...Qs.parse(QueryTypes.parseObject(this.$route.query))
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.loadData()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Record.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Record.Filter.by['DESC'].value

            break

          case this.$store.state.register.Record.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Record.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.loadData()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.loadData()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.loadData()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.loadData()
      },
      loadData() {
        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Records
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.records = response.data.data.records

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
